import { useTranslation } from 'react-i18next';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function AboutMentor() {
  const { t } = useTranslation();

  const skills = [
    t('phoenix.aboutSkill1'),
    t('phoenix.aboutSkill2'),
    t('phoenix.aboutSkill3'),
    t('phoenix.aboutSkill4'),
    t('phoenix.aboutSkill5'),
    t('phoenix.aboutSkill6'),
  ];

  return (
    <section className="relative py-20 md:py-28 bg-white">
      <div className="mx-auto max-w-[1100px] px-6 md:px-10">
        <ScrollReveal direction="up">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-50 border border-primary-200/50 text-primary-700 text-xs font-semibold tracking-wide uppercase mb-4">
            {t('phoenix.aboutTag')}
          </span>
        </ScrollReveal>

        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-16 mt-12">
          <ScrollReveal direction="left" delay={0.1} className="shrink-0">
            <div className="relative">
              <div className="w-56 h-56 md:w-72 md:h-72 rounded-3xl overflow-hidden border-2 border-background-200 shadow-[0_8px_40px_rgba(0,0,0,0.08)]">
                <img
                  src="https://static.readdy.ai/image/ea473d33d180c87428df5c28ba90939d/90e239465f1b2a75158e6ad13a1e9e3e.jpeg"
                  alt={t('phoenix.aboutTitle')}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 bg-accent-500 text-white rounded-2xl px-4 py-2.5 shadow-[0_4px_16px_rgba(200,162,74,0.35)]">
                <p className="text-[10px] uppercase tracking-wider opacity-80 font-medium">+100</p>
                <p className="text-xs font-bold">Clientes</p>
              </div>
            </div>
          </ScrollReveal>

          <ScrollReveal direction="right" delay={0.15} className="flex-1">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-1">
              {t('phoenix.aboutTitle')}
            </h2>
            <p className="text-primary-500 font-semibold text-sm mb-5">{t('phoenix.aboutRole')}</p>
            <p className="text-foreground-600 text-base leading-relaxed mb-6 max-w-[600px]">
              {t('phoenix.aboutBio')}
            </p>
            <div className="flex flex-wrap gap-2 mb-5">
              {skills.map((skill, i) => (
                <span key={i} className="px-3 py-1.5 rounded-full bg-primary-100 border border-primary-200 text-primary-700 text-xs font-medium hover:bg-primary-200 hover:border-primary-300 hover:text-primary-800 transition-colors duration-200 cursor-default">
                  {skill}
                </span>
              ))}
            </div>
            <p className="text-foreground-400 text-sm italic flex items-center gap-2">
              <i className="ri-double-quotes-l text-accent-500"></i>
              {t('phoenix.aboutFocus')}
            </p>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}